// Red Ritual — tema Shopify. Sin dependencias.
(() => {
  'use strict';
  const RR = window.RR || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const fmt = new Intl.NumberFormat(RR.locale || 'es-ES', { style: 'currency', currency: RR.currency || 'EUR' });
  const money = (cents) => fmt.format((cents || 0) / 100);
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const desktop = matchMedia('(min-width: 900px) and (pointer: fine)').matches;
  const lite = reduced || (navigator.connection && navigator.connection.saveData) || (navigator.hardwareConcurrency || 8) <= 4;
  if (lite) document.documentElement.classList.add('lite');
  const inEditor = window.Shopify && window.Shopify.designMode;

  /* ---------- Partículas (color del modo) ---------- */
  const canvas = $('[data-fx]');
  if (canvas && !reduced) {
    const ctx = canvas.getContext('2d');
    const dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    const count = lite ? 16 : desktop ? 60 : 28;
    let w = 0, h = 0, run = true, n = 0, tint = '#FF1744';
    const resize = () => { w = canvas.clientWidth; h = canvas.clientHeight; canvas.width = w * dpr; canvas.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); };
    const spawn = () => ({ x: Math.random() * w, y: Math.random() * h, r: Math.random() * 1.4 + .4, vy: -(Math.random() * .18 + .04), vx: (Math.random() - .5) * .08, a: Math.random() * .5 + .15, t: Math.random() * 6, z: Math.random() * .8 + .2 });
    resize();
    const parts = Array.from({ length: count }, spawn);
    addEventListener('resize', resize, { passive: true });
    const frame = () => {
      if (!run) return;
      if (n++ % 20 === 0) tint = getComputedStyle(document.documentElement).getPropertyValue('--neon').trim() || tint;
      ctx.clearRect(0, 0, w, h);
      for (const p of parts) {
        p.x += p.vx; p.y += p.vy; p.t += .02;
        if (p.y < -10) Object.assign(p, spawn(), { y: h + 10 });
        ctx.globalAlpha = p.a * (.6 + .4 * Math.sin(p.t));
        ctx.fillStyle = tint; ctx.shadowColor = tint; ctx.shadowBlur = lite ? 0 : 8 * p.z;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r * p.z + .3, 0, Math.PI * 2); ctx.fill();
      }
      ctx.globalAlpha = 1;
      requestAnimationFrame(frame);
    };
    requestAnimationFrame(frame);
    document.addEventListener('visibilitychange', () => { run = !document.hidden; if (run) requestAnimationFrame(frame); });
  }

  /* ---------- Cabecera, progreso, menú ---------- */
  const header = $('[data-header]');
  const bar = $('[data-progress]');
  let ticking = false;
  const onScroll = () => {
    if (ticking) return; ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      if (header) header.classList.toggle('scrolled', scrollY > 10);
      const max = document.documentElement.scrollHeight - innerHeight;
      if (bar) bar.style.transform = `scaleX(${max > 0 ? Math.min(1, scrollY / max) : 0})`;
    });
  };
  onScroll(); addEventListener('scroll', onScroll, { passive: true });
  // Altura real de la cabecera fija (avisos + barra Liquid + logo) para que el contenido empiece justo debajo
  if (header) {
    const setHeaderH = () => document.documentElement.style.setProperty('--hdr', `${header.offsetHeight}px`);
    setHeaderH();
    addEventListener('resize', setHeaderH);
    if ('ResizeObserver' in window) new ResizeObserver(setHeaderH).observe(header);
  }
  const menu = $('[data-menu]');
  const menuBtn = $('[data-menu-open]');
  const setMenu = (open) => { if (!menu) return; menu.hidden = !open; menuBtn && menuBtn.setAttribute('aria-expanded', String(open)); document.body.style.overflow = open ? 'hidden' : ''; };
  menuBtn && menuBtn.addEventListener('click', () => setMenu(true));
  menu && menu.addEventListener('click', (e) => { if (e.target === menu || e.target.closest('[data-menu-close]') || e.target.closest('a')) setMenu(false); });

  /* ---------- Modos de color ---------- */
  let mode = document.documentElement.dataset.mode || 'ems';
  const flash = document.createElement('div');
  flash.className = 'mode-flash'; flash.setAttribute('aria-hidden', 'true'); document.body.appendChild(flash);
  const setMode = (m) => {
    if (!['clean', 'ems', 'hot'].includes(m) || m === mode) return;
    mode = m;
    if (m === 'ems') delete document.documentElement.dataset.mode; else document.documentElement.dataset.mode = m;
    $$('[data-mode-set]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.modeSet === m)));
    if (!reduced) { flash.classList.remove('go'); void flash.offsetWidth; flash.classList.add('go'); }
  };
  document.addEventListener('click', (e) => { const b = e.target.closest('[data-mode-set]'); if (b) setMode(b.dataset.modeSet); });
  const steps = $$('[data-story-mode]');
  if (steps.length && 'IntersectionObserver' in window) {
    const so = new IntersectionObserver((en) => en.forEach((x) => { if (x.isIntersecting) setMode(x.target.dataset.storyMode); }), { rootMargin: '-45% 0px -45% 0px' });
    steps.forEach((s) => so.observe(s));
  }

  /* ---------- Avisos rotativos ---------- */
  const ann = $$('[data-announce] > span');
  if (ann.length > 1 && !reduced) {
    let ai = 0;
    setInterval(() => { ann[ai].classList.remove('on'); ai = (ai + 1) % ann.length; ann[ai].classList.add('on'); }, 3800);
  }

  /* ---------- Carrito (API AJAX de Shopify) ---------- */
  const drawer = $('[data-drawer]');
  const countEl = $('[data-cart-count]');
  const compareCache = {};
  let cart = null;
  const api = async (url, body) => {
    const r = await fetch(url, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } });
    const j = await r.json();
    if (!r.ok) throw new Error(j.description || j.message || 'No se pudo actualizar el carrito');
    return j;
  };
  const loadCompare = async (handle) => {
    if (compareCache[handle]) return compareCache[handle];
    try {
      const p = await (await fetch(`${RR.routes.root}products/${handle}.js`)).json();
      compareCache[handle] = Object.fromEntries(p.variants.map((v) => [v.id, v.compare_at_price || 0]));
    } catch { compareCache[handle] = {}; }
    return compareCache[handle];
  };
  const renderCart = async () => {
    if (!cart) return;
    const items = cart.items;
    let save = 0;
    for (const it of items) {
      const c = (await loadCompare(it.handle))[it.variant_id] || 0;
      if (c > it.price) save += (c - it.price) * it.quantity;
    }
    if (countEl) { countEl.textContent = cart.item_count; countEl.hidden = cart.item_count === 0; }
    const html = items.length === 0
      ? `<div class="cart-empty"><p>Tu carrito está vacío.</p><a class="btn" href="${RR.routes.root}collections/all">Ver productos</a></div>`
      : items.map((it, i) => `<div class="line">
          <div class="line-img">${it.image ? `<img src="${it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2')}" alt="" width="64" height="64" style="object-fit:cover;width:100%;height:100%">` : ''}</div>
          <div><div class="line-t">${it.product_title}${it.variant_title ? ` · ${it.variant_title}` : ''}</div>
            <div><span class="qty"><button type="button" aria-label="Quitar uno" data-line="${i + 1}" data-q="${it.quantity - 1}">−</button><span>${it.quantity}</span><button type="button" aria-label="Añadir uno" data-line="${i + 1}" data-q="${it.quantity + 1}">+</button></span><button type="button" class="line-rm" data-line="${i + 1}" data-q="0">Eliminar</button></div>
          </div>
          <div class="line-p">${it.original_line_price > it.final_line_price ? `<s>${money(it.original_line_price)}</s>` : ''}${money(it.final_line_price)}</div>
        </div>`).join('');
    $$('[data-cart-lines]').forEach((el) => { el.innerHTML = html; });
    $$('[data-cart-foot]').forEach((el) => { el.hidden = items.length === 0; });
    $$('[data-cart-total]').forEach((el) => { el.textContent = money(cart.total_price); });
    $$('[data-cart-save]').forEach((el) => { el.textContent = money(save); el.parentElement.hidden = save === 0; });
    const up = RR.upsell || {};
    const showUp = up.enabled && up.from && up.to && items.length === 1 && items[0].variant_id === up.from && items[0].quantity === 1;
    $$('[data-cart-upsell]').forEach((el) => { el.hidden = !showUp; });
    $$('[data-cart-addon]').forEach((el) => { el.hidden = items.length === 0; });
    const sb = $('[data-ship-bar]');
    if (sb) {
      const free = Number(sb.dataset.free) * 100;
      const left = Math.max(0, free - cart.total_price);
      $('[data-ship-text]', sb).textContent = left > 0 ? `Te faltan ${money(left)} para el envío gratis` : 'Tienes el envío gratis';
      $('i', sb).style.setProperty('--p', `${Math.min(100, (cart.total_price / free) * 100)}%`);
    }
  };
  const refresh = async () => { cart = await api(RR.routes.cartJs); await renderCart(); };
  let lastFocus = null;
  const openCart = () => {
    if (!drawer) return;
    lastFocus = document.activeElement; drawer.hidden = false; document.body.style.overflow = 'hidden';
    const c = $('.icon-btn[data-cart-close]', drawer); c && c.focus();
  };
  const closeCart = () => { if (!drawer) return; drawer.hidden = true; document.body.style.overflow = ''; lastFocus && lastFocus.focus(); };
  const addToCart = async (id, qty = 1, go = null) => {
    await api(RR.routes.cartAdd, { items: [{ id: Number(id), quantity: qty }] });
    await refresh();
    if (countEl) { countEl.classList.remove('bump'); void countEl.offsetWidth; countEl.classList.add('bump'); }
    if (go === 'checkout') { location.href = `${RR.routes.root}checkout`; return; }
    if (RR.cartType === 'page') { location.href = RR.routes.cart; return; }
    openCart();
  };
  document.addEventListener('click', async (e) => {
    const t = e.target;
    if (t.closest('[data-cart-open]') && RR.cartType !== 'page' && !document.body.classList.contains('template-cart')) { e.preventDefault(); openCart(); return; }
    if (t.closest('[data-cart-close]')) { closeCart(); return; }
    const quick = t.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault(); quick.disabled = true;
      try { await addToCart(quick.dataset.quickAdd); } catch (err) { alertInline(quick, err.message); }
      quick.disabled = false; return;
    }
    const addon = t.closest('[data-cart-addon-add]');
    if (addon) {
      addon.disabled = true;
      try { await api(RR.routes.cartAdd, { items: [{ id: Number(addon.dataset.cartAddonAdd), quantity: 1 }] }); await refresh(); } catch (err) { alertInline(addon, err.message); }
      addon.disabled = false; return;
    }
    const q = t.closest('[data-line]');
    if (q) { cart = await api(RR.routes.cartChange, { line: Number(q.dataset.line), quantity: Math.max(0, Number(q.dataset.q)) }); await renderCart(); return; }
    if (t.closest('[data-cart-upgrade]')) {
      const up = RR.upsell;
      cart = await api(RR.routes.cartChange, { line: 1, quantity: 0 });
      await api(RR.routes.cartAdd, { items: [{ id: up.to, quantity: 1 }] });
      await refresh();
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { if (drawer && !drawer.hidden) closeCart(); if (menu && !menu.hidden) setMenu(false); } });
  const alertInline = (near, msg) => {
    let p = near.parentElement.querySelector('.checkout-msg');
    if (!p) { p = document.createElement('p'); p.className = 'checkout-msg'; near.after(p); }
    p.textContent = msg; p.hidden = false;
  };
  refresh().catch(() => {});
  // Apps como EasySell añaden al carrito por su cuenta: se repinta el carrito cuando cualquier script lo modifica
  let syncT = 0;
  const syncCart = () => { clearTimeout(syncT); syncT = setTimeout(() => refresh().catch(() => {}), 250); };
  const isCartWrite = (u) => /\/cart\/(add|change|update|clear)/.test(String(u || ''));
  const origFetch = window.fetch;
  window.fetch = function (input, init) {
    const p = origFetch.apply(this, arguments);
    try { if (isCartWrite(input && input.url ? input.url : input)) p.then(syncCart, () => {}); } catch (e) {}
    return p;
  };
  const xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartWrite(url)) this.addEventListener('loadend', syncCart);
    return xhrOpen.apply(this, arguments);
  };
  document.addEventListener('click', (e) => { if (e.target.closest('[data-cart-open]')) syncCart(); }, true);

  /* ---------- Ficha de producto ---------- */
  // Se leen en cada uso (no al cargar) porque el editor de temas vuelve a pintar la sección al editarla
  const getPdata = () => { const el = $('[data-product-json]'); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } };
  const getVariantInput = () => $('[data-variant-input]');
  let qty = 1;
  const selectVariant = (id, smooth = true) => {
    const pdata = getPdata();
    if (!pdata) return;
    const v = pdata.variants.find((x) => x.id === Number(id));
    if (!v) return;
    const variantInput = getVariantInput();
    if (variantInput) variantInput.value = v.id;
    $$('[data-packs] .pack').forEach((el) => { const on = Number(el.dataset.pack) === v.id; el.classList.toggle('is-selected', on); const i = $('input', el); if (i) i.checked = on; });
    $$('[data-pdp-price], [data-cta-price], [data-sticky-price]').forEach((el) => { el.textContent = money(v.price); });
    $$('[data-pdp-was]').forEach((el) => { el.textContent = v.compare > v.price ? money(v.compare) : ''; el.hidden = !(v.compare > v.price); });
    const pct = v.compare > v.price ? Math.round((1 - v.price / v.compare) * 100) : 0;
    $$('[data-pdp-save]').forEach((el) => { const txt = v.pill || (pct ? `Ahorras ${pct} %` : ''); el.textContent = txt; el.hidden = !txt; });
    $$('[data-pdp-sub]').forEach((el) => { if (v.subtitle) el.textContent = v.subtitle; });
    $$('[data-sticky-name]').forEach((el) => { el.textContent = v.name; });
    $$('[data-add-selected], [data-buy-now], [data-sticky-buy="add"]').forEach((b) => { b.disabled = !v.available; });
    if (!inEditor) { const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
    // Muestra en la galería la foto asignada a este pack (si tiene una)
    if (v.media) {
      const rail = $('[data-g-track]');
      const items = rail ? $$('.g-item', rail) : [];
      const i = items.findIndex((el) => Number(el.dataset.mediaId) === v.media);
      if (i >= 0) rail.scrollTo({ left: i * rail.clientWidth, behavior: reduced || !smooth ? 'auto' : 'smooth' });
    }
  };
  if (getVariantInput()) selectVariant(getVariantInput().value, false);
  // Delegado en document: sigue funcionando aunque el editor vuelva a pintar la ficha
  document.addEventListener('change', (e) => { if (e.target.closest('[data-packs]') && e.target.value) selectVariant(e.target.value); });
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    qty = Math.max(1, Math.min(20, qty + Number(b.dataset.qtyStep)));
    $$('[data-qty-value]').forEach((el) => { el.textContent = qty; });
    const qi = $('[data-qty-input]'); if (qi) qi.value = qty;
  });
  const go = async (mode2) => {
    const err = $('[data-form-error]');
    try { if (err) err.hidden = true; await addToCart(getVariantInput().value, qty, mode2); }
    catch (e) { if (err) { err.textContent = e.message; err.hidden = false; } }
  };
  // Botón único: si el bloque tiene data-cod-only, «Comprar» y la barra fija abren el formulario de EasySell
  const openCod = () => {
    if (!$('[data-cod-only]')) return false;
    const es = $('.es-popup-button-product') || $('#es-popup-button');
    if (!es) return false;
    (es.querySelector('button, a, .es-button-title') || es).click();
    return true;
  };
  document.addEventListener('click', (e) => { if (e.target.closest('[data-buy-now], [data-sticky-buy="add"]') && openCod()) { e.preventDefault(); e.stopImmediatePropagation(); } }, true);
  document.addEventListener('submit', (e) => { if (e.target.closest('[data-product-form]')) { e.preventDefault(); go(null); } });
  document.addEventListener('click', (e) => { if (e.target.closest('[data-buy-now]')) go('checkout'); });

  /* ---------- Barra fija móvil ---------- */
  const sticky = $('[data-sticky]');
  if (sticky) {
    const visible = new Set();
    let past = false;
    const hero = $('.hero-lq, .pdp-top');
    const threshold = () => (hero ? hero.offsetTop + hero.offsetHeight * 0.55 : 320);
    const update = () => sticky.classList.toggle('on', past && visible.size === 0 && (!drawer || drawer.hidden));
    sticky.hidden = false;
    const io = new IntersectionObserver((en) => { en.forEach((x) => (x.isIntersecting ? visible.add(x.target) : visible.delete(x.target))); update(); });
    $$('[data-cta-watch]').forEach((el) => io.observe(el));
    addEventListener('scroll', () => { const p = scrollY > threshold(); if (p !== past) { past = p; update(); } }, { passive: true });
    if (drawer) new MutationObserver(update).observe(drawer, { attributes: true, attributeFilter: ['hidden'] });
    const sb = $('[data-sticky-buy="add"]', sticky);
    if (sb) sb.addEventListener('click', () => { const f = $('[data-product-form]'); if (f) (f.requestSubmit ? f.requestSubmit() : go(null)); });
  }

  /* ---------- Galería con puntos ---------- */
  const gallery = $('[data-gallery]');
  if (gallery) {
    const rail = $('[data-g-track]', gallery);
    const dotsWrap = $('.g-dots', gallery);
    const items = $$('.g-item', rail);
    if (dotsWrap && items.length > 1) dotsWrap.innerHTML = items.map((_, i) => `<i${i === 0 ? ' class="on"' : ''}></i>`).join('');
    const dots = $$('i', dotsWrap);
    let raf = 0;
    rail.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => { const i = Math.round(rail.scrollLeft / rail.clientWidth); dots.forEach((d, j) => d.classList.toggle('on', i === j)); }); }, { passive: true });
    const goTo = (i) => rail.scrollTo({ left: Math.max(0, Math.min(items.length - 1, i)) * rail.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
    // Los puntos también sirven para cambiar de foto
    dots.forEach((d, i) => { d.style.cursor = 'pointer'; d.addEventListener('click', () => goTo(i)); });
    // Con ratón: arrastrar para pasar de foto (en móvil ya se desliza con el dedo)
    $$('img', rail).forEach((im) => { im.draggable = false; });
    let down = null;
    rail.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse' || e.button !== 0) return; down = { x: e.clientX, left: rail.scrollLeft, moved: false }; rail.style.scrollSnapType = 'none'; rail.style.cursor = 'grabbing'; });
    addEventListener('pointermove', (e) => { if (!down) return; const dx = e.clientX - down.x; if (Math.abs(dx) > 4) down.moved = true; rail.scrollLeft = down.left - dx; });
    addEventListener('pointerup', (e) => {
      if (!down) return;
      const dx = e.clientX - down.x, start = Math.round(down.left / rail.clientWidth);
      const moved = down.moved; down = null; rail.style.scrollSnapType = ''; rail.style.cursor = '';
      goTo(Math.abs(dx) > rail.clientWidth * 0.15 ? start + (dx < 0 ? 1 : -1) : start);
      if (moved) rail.addEventListener('click', (ev) => ev.preventDefault(), { capture: true, once: true });
    });
    // Teclado: flechas izquierda/derecha cuando la galería tiene el foco
    rail.addEventListener('keydown', (e) => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.round(rail.scrollLeft / rail.clientWidth) + (e.key === 'ArrowRight' ? 1 : -1)); } });
  }

  /* ---------- Aparición al hacer scroll ---------- */
  const reveals = $$('.reveal');
  if ('IntersectionObserver' in window && !reduced && !document.body.classList.contains('no-anim') && !inEditor) {
    const ro = new IntersectionObserver((en) => en.forEach((x) => { if (x.isIntersecting) { x.target.classList.add('in'); ro.unobserve(x.target); } }), { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach((el) => ro.observe(el));
  } else reveals.forEach((el) => el.classList.add('in'));

  /* ---------- Editor de temas: re-inicializar al editar secciones ---------- */
  if (inEditor) document.addEventListener('shopify:section:load', () => { $$('.reveal').forEach((el) => el.classList.add('in')); });
})();
